// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"1640beaf","205":"ce5122d3","777":"26614da8"}[chunkId] + ".chunk.js";
};